import React from "react";
import { useEffect, useState } from "react";

import { useFormik } from "formik";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "../../../Services/axiosCommon";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../Components/Utils/Buttons";
import Attachement from "./Attachement";

import * as yup from "yup";
import { notification } from "antd";
import useFetchMataData from "../../../Components/Hooks/useFetchMataData";

import Breadcrumb from "../../../Components/Utils/Breadcrumb";
import Dashboard from "../Dashboard";
import FormikSelectTwo from "../../../Components/Utils/Select";
import { NuDate, NuInput, NuTextArea, NuTime } from "../../../Components/Utils/Input";

const filetype = ["docx", "doc", "xlsx", "xls", "pdf", "txt", "pptx","mp4", "mov", "wmv", "avi", "flv", "mkv"];
// export const videotype = ["mp4", "mov", "wmv", "avi", "flv", "mkv"];

export default function NoteCreate({ data }) {
  const {officeId} =useParams();
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState([]);
  const [status, setStatus] = useState([]);
  const [createNew, setCreateNew] = useState({
    title: "",
    description: "",
    status: "",
    reminder_date: "",
    reminder_time: "",
    due_date: "",
  });
  const { value: noteStatus } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "noteStatus"
  );

  const [selectedFile, setSelectedFile] = useState(null);
  const [filePathList,setFilePathList] =useState([])
  const [removefilePathList,setRemoveFilePathList] =useState([])

  function handleImageChange(e) {
    const maxFileSize = 200000000; // 200 MB
    const files = Array.from(e.target.files);
    let fileArr = []
    files.map(item=>{
      if (item.size < maxFileSize ){
        fileArr.push(item)
      }else{
        api.warning({
          message: `File Size to big`,
          description: `${item.name} is Removed and not Uploaded`,
          placement: "bottomRight",
        });
      }
    })    
    let tempArr = []
    setSelectedFile(fileArr);
    files.map(item=>{
      if (item.size < maxFileSize ){
      let fileName = item?.name
      let fileExtention =  fileName.split(".").reverse()[0]
      if(filetype?.includes(fileExtention)){
        tempArr.push(fileName)
      }else{
        let x = URL.createObjectURL(item)
        tempArr.push(x)
      }
    }
    })
    setImage(tempArr)
  }

  // const getStatus = () => {
  //   axios
  //     .get(`/Metadata/noteStatus`)
  //     .then((res) => {
  //       let data = res.data?.data?.keyValues;
  //       let tempData = [];
  //       data.forEach((item) => {
  //         let tempObject = { value: item, label: item };
  //         tempData.push(tempObject);
  //       });
  //       res.data?.data?.keyValues && setStatus(tempData);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });
  // };

  // let {value} = useFetchMataData("/Metadata/noteStatus")



  useEffect(() => {
    // getStatus();
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: true,
    validationSchema: yup.object({
      title: yup.string().required("Title is Required"),
      // status: yup.string().required("Please Select Status"),
    }),
    onSubmit: async (value) => {
      setIsLoading(true);
      let formData = new FormData();
      formData.append("my_notes", JSON.stringify(value));
      // formData.append("attachments", image.raw);
      if(selectedFile !== null){
        selectedFile.forEach((file) => {
          formData.append("attachments", file);
        });
      }else{
        formData.append("attachments",[])
      } 

      data
        ? axios
            .put(`/Notes${data?.notesId}`, formData)
            .then((res) => {
              if (res.status == 201 || res.data.status == true) {
                setIsLoading(false);
                setImage({ preview: "", raw: "" });
                api.success({
                  message: `Add successfully`,
                  description: res?.data?.msg || " created",
                  placement: "bottomRight",
                });
                navigate(-1);
              } else {
                setIsLoading(false);
                api.error({
                  message: `Unsuccessfully`,
                  description: res?.data?.msg || "creation failed",
                  placement: "bottomRight",
                });
              }
            })
            .catch((err) => {
              setIsLoading(false);
              api.error({
                message: `Unsuccessfully`,
                description: err?.response?.data?.msg || "creation failed",
                placement: "bottomRight",
              });
            })
        : axios
            .post("/Notes/", formData)
            .then((res) => {
              if (res.status == 201 || res.data.status == true) {
                setIsLoading(false);
                setImage([]);
                api.success({
                  message: `Add successfully`,
                  description: res?.data?.msg || " created",
                  placement: "bottomRight",
                });
                navigate(-1);
              } else {
                setIsLoading(false);
                api.error({
                  message: `Unsuccessfully`,
                  description: res?.data?.msg || "creation failed",
                  placement: "bottomRight",
                });
              }
            })
            .catch((err) => {
              setIsLoading(false);
              api.error({
                message: `Unsuccessfully`,
                description: err?.response?.data?.msg || "creation failed",
                placement: "bottomRight",
              });
            });
    },
  });
  return (
    <div className="w-full mx-auto py-2 px-4 ">
      {contextHolder}
      <div className="md:flex justify-between w-full">
      <Breadcrumb
          items={[
           
            {
              name: "My Diary", link:`/dairy`
            },
            { name: "Create" },
          ]}
        />

        <div className=" flex gap-2 items-center mr-6">
          <BackButton />
        </div>
      </div>
      <div>
      <div
          className=" w-full mx-auto h-[calc(100vh-145px)] rounded-[6px] mt-2 overflow-y-scroll bg-white"
          // style={{ border: "1px solid #C5C5C5" }}
        >
          <form onSubmit={formik.handleSubmit}>
          <div className="w-full">
                <p className="py-2 px-4 text-xs 2xl:text-sm font-medium text-[#111537] underline decoration-[#048178] decoration-2 underline-offset-4">
                  My Diary :
                </p>
              </div>
            <div className="flex flex-wrap justify-between">
             
                <NuInput
                 type="text"
                  label="Title"
                  isRequired={true}
                  placeholder="Title"
                  formik={formik}
                  name="title"
                  width="w-full md:w-1/2"
                />
                {/* <FormikSelectTwo
                  label="Status"
                  Options={noteStatus}
                  formik={formik}
                  placeholder="Choose"
                  name="status"
                  width="w-full md:w-1/4"
                  isRequired={true}
                /> */}
                 <FormikSelectTwo
                  label="Status"
                  Options={noteStatus}
                  formik={formik}
                  placeholder="Choose"
                  name="status"
                  width="w-full md:w-1/4"
                  isRequired={true}
                />
               <NuDate
                  label="Due date"
                  formik={formik}
                  name="due_date"
                  min={NuDate({
                    value: Date.now(),
                    format: "yyyy-MM-DD",
                  })}
                  width=" w-full md:w-1/4"
                />

                <NuTextArea
                  label="Description"
                  placeholder="Description"
                  formik={formik}
                  name="description"
                  width="w-full md:w-1/2"
                />

<NuDate
                label="Reminder date"
                formik={formik}
                name="reminder_date"
                min={NuDate({
                  value: Date.now(),
                  format: "yyyy-MM-DD",
                })}
                width=" w-full md:w-1/4"
              />
             <NuTime
                // disabled={formik.values.reminder_date ? false : true}
                label="Reminder Time "
                de
                formik={formik}
                name="reminder_time"
                width=" w-full md:w-1/4"
                min={new Date()}
              />
                <Attachement
                  handleChange={handleImageChange}
                  preview={image || data?.imageUrl || ""}
                  width="w-full md:w-1/2"
                  label="Attach"
                  multiple={true}

                />

            </div>
            <div className="flex justify-between items-center">
              <div className="w-1/2">

              </div>

              <div
                className=" mr-2 rounded-md"
                style={{ border: "1px solid #C5C5C5" }}
              >

              </div>
            </div>

            <div className="flex justify-end item-end float-right mx-auto md:mx-0 gap-2 pb-4 mt-6 md:mr-4">
              <CancelButton handleClick={() => navigate(-1)} />
              <SubmitButton isLoading={isLoading} />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
